var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.props)?_c('payment-details',{attrs:{"props":_vm.props}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }